import { Divider, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ReactElement } from 'react';
import MainImage from '../../../assets/bio9.jpeg';
import { InfoCard } from '../Card';
import Publications from 'components/Publications/Publications';

export const About = (): ReactElement =>
(
	<Grid container spacing={2}>
		<Grid item xs={12}>
			<InfoCard content={
				<>
					<Box sx={{ margin: '16px 0' }}>
						<Typography>
							Puracyp is dedicated to providing high quality research with a primary focus on high volume screening of new chemical entities to identify potential inducers of P450 enzymes and ABC transporters. Puracyp’s nuclear receptor activation service utilizes either stably integrated cell lines or transiently transfected cells harboring P450 enhancer elements in reporter gene constructs and human or animal nuclear receptors including PXR, CAR and AhR. Nuclear receptor assays currently available include those employing the CYP3A, CYP2B, P-glycoprotein or CYP1A2-DRE enhancers and promoters.
						</Typography>
					</Box>
					<Divider />
					<Box sx={{ margin: '16px 0' }}>
						<Typography>
							Nuclear receptors derived from various species are also available that can alleviate many animal studies and provide valuable information regarding a NCE and its potential to alter pharmacokinetic parameters. Information gained from employing human nuclear receptors can be used to predict in vivo responses from NCEs with regards to drug-drug interactions and adverse drug effects.
						</Typography>
					</Box>
					<Divider />
					<Box sx={{ margin: '16px 0' }}>
						<Typography>
							Puracyp’s scientists are extensively published and have been involved in human P450 metabolism research for a number of years. Presently, the company has two main divisions, products and services. Products now include kits that are all inclusive and contain our stably integrated human or rat PXR and human AhR cell lines. Puracyp also offers vials of our cryopreserved DPX2, 1A2-DRE and rPXR cells in 6 or 12 million cells per vial that can be formatted for 96 or 384 well plate analyses.
						</Typography>
					</Box>
				</>
			} media={MainImage}
				mediaHeight={394}
				mediaTitle="Cells"
				title="About Puracyp" />
		</Grid>
		<Grid item sm={4} xs={12}>
			<InfoCard
				content={(
					<>
						<Divider />
						<Box sx={{ margin: '16px 0' }}>
							<Typography variant="body1" color="text.primary">
								As CEO, Mr. Dale is responsible for both the corporate governance and the sales and marketing activities of Puracyp. Prior to founding the company with Dr. Raucy in 1999, Mr. Dale had over 30 years of experience as a CPA and entrepreneur, including many years as a partner or owner of CPA firms. He also worked as a manager for American Express Small Business Services and as CEO of a health care products company. Mr. Dale received his B. S. in accounting from Bemidji State University, Bemidji, MN.
							</Typography>
						</Box>
					</>
				)}
				media=""
				mediaHeight={494}
				mediaTitle="Laboratory Work"
				title={(
					<>
						<strong>
							Mark A. Dale
						</strong>
						<Typography>
							Chief Executive Officer
						</Typography>
					</>

				)}
			/>
		</Grid>
		<Grid item sm={4} xs={12}>
			<InfoCard
				content={(
					<>
						<Divider />
						<Box sx={{ margin: '16px 0' }}>
							<Typography variant="body1" color="text.primary">
								As chief scientist, Dr. Raucy oversees the implementation and validation of receptor activation studies. She is also involved in the research and development of new products. Prior to founding Puracyp Inc. with Mr. Dale, Dr. Raucy held a faculty position at the University of New Mexico's College of Pharmacy. She has more than 25 years of experience in the area of drug metabolism and P450 gene regulation. Dr. Raucy received her Ph.D. in toxicology from Utah State University and her B.S. from the University of Utah.
							</Typography>
						</Box>
					</>
				)}
				media=""
				mediaHeight={494}
				mediaTitle="Laboratory Work"
				title={(
					<>
						<strong>
							Judy Raucy
						</strong>
						<Typography>
							Ph.D. and Chief Scientific Officer
						</Typography>
					</>
				)}
			/>
		</Grid>
		<Grid item sm={4} xs={12}>
			<InfoCard
				content={(
					<>
						<Divider />
						<Box sx={{ margin: '16px 0' }}>
							<Typography variant="body1" color="text.primary">
								Dr. Pinne is involved in Research and Development of new tools for nuclear receptor activation. She directs and analyzes the results from induction studies. She has more than 17 years experience in Molecular Biology . Her numerous research articles have been published in various scientific journals. Dr. Pinne received her PhD in Medical Microbiology from Umea University, Sweden and her M.Sc., B.Sc. from University of Latvia. Dr. Pinne completed Post-Doctoral training at Department of Medicine, University of California, Los Angeles.
							</Typography>
						</Box>
					</>
				)}
				media=""
				mediaHeight={494}
				mediaTitle="Laboratory Work"
				title={(
					<>
						<strong>
							Marija Pinne
						</strong>
						<Typography>
							Ph.D. and Director of Laboratory Operations
						</Typography>
					</>
				)}
			/>
		</Grid>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<InfoCard
					content={(
						<>
							<Divider />
							<Publications />
						</>
					)}
					media=""
					mediaHeight={494}
					mediaTitle="Laboratory Work"
					title={(
						<>
							<strong>
								Publications
							</strong>
						</>
					)}
				/>
			</Grid>
		</Grid>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<InfoCard
					content={(
						<>
							<Divider />
							<Box sx={{ margin: '16px 0' }}>
								<Typography>
									Privacy Policy Protecting your private information is our priority. This Statement of Privacy applies to puracyp.com and Puracyp, Inc. and governs data collection and usage. For the purposes of this Privacy Policy, unless otherwise noted, all references to Puracyp, Inc. include puracyp.com. The Puracyp, Inc. website is a News and Information and Commerce site. By using the Puracyp, Inc. website, you consent to the data practices described in this statement. Collection of your Personal Information We do not collect any personal information about you unless you voluntarily provide it to us. However, you may be required to provide certain personal information to us when you elect to use certain products or services available on the Site. These may include: (a) registering for an account on our Site; (b) sending us an email message; (c) submitting your credit card or other payment information when ordering and purchasing products and services on our Site. To wit, we will use your information for, but not limited to, communicating with you in relation to services and/or products you have requested from us. We also may gather additional personal or non-personal information in the future. Sharing Information with Third Parties Puracyp, Inc. does not sell, rent or lease its customer lists to third parties. Puracyp, Inc. may share data with trusted partners to help perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to Puracyp, Inc., and they are required to maintain the confidentiality of your information. Puracyp, Inc. may disclose your personal information, without notice, if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on Puracyp, Inc. or the site; (b) protect and defend the rights or property of Puracyp, Inc.; and/or (c) act under exigent circumstances to protect the personal safety of users of Puracyp, Inc., or the public. Automatically Collected Information Information about your computer hardware and software may be automatically collected by Puracyp, Inc.. This information can include: your IP address, browser type, domain names, access times and referring website addresses. This information is used for the operation of the service, to maintain quality of the service, and to provide general statistics regarding use of the Puracyp, Inc. website. Security of your Personal Information Puracyp, Inc. secures your personal information from unauthorized access, use, or disclosure. Puracyp, Inc. uses the following methods for this purpose: When personal information (such as a credit card number) is transmitted to other websites, it is protected through the use of encryption, such as the Secure Sockets Layer (SSL) protocol. We strive to take appropriate security measures to protect against unauthorized access to or alteration of your personal information. Unfortunately, no data transmission over the Internet or any wireless network can be guaranteed to be 100% secure. As a result, while we strive to protect your personal information, you acknowledge that: (a) there are security and privacy limitations inherent to the Internet which are beyond our control; and (b) security, integrity, and privacy of any and all information and data exchanged between you and us through this Site cannot be guaranteed. E-mail Communications From time to time, Puracyp, Inc. may contact you via email for the purpose of providing announcements, promotional offers, alerts, confirmations, surveys, and/or other general communication. In order to improve our Services, we may receive a notification when you open an email from Puracyp, Inc. or click on a link therein. Changes to this Statement Puracyp, Inc. reserves the right to change this Privacy Policy from time to time. We will notify you about significant changes in the way we treat personal information by sending a notice to the primary email address specified in your account, by placing a prominent notice on our site, and/or by updating any privacy information on this page. Your continued use of the Site and/or Services available through this Site after such modifications will constitute your: (a) acknowledgment of the modified Privacy Policy; and (b) agreement to abide and be bound by that Policy. Contact Information Puracyp, Inc. welcomes your questions or comments regarding this Statement of Privacy. If you believe that Puracyp, Inc. has not adhered to this Statement, please contact Puracyp, Inc. at: Puracyp, Inc. 5900 Sea Lion Place, Suite 130 Carlsbad, California 92078 Email Address: mdale@puracyp.com Telephone number: 760-929-9508 x 106 Effective as of January 1, 2019</Typography>
							</Box>
						</>
					)}
					media=""
					mediaHeight={494}
					mediaTitle="Laboratory Work"
					title={(
						<>
							<strong>
								Privacy Policy
							</strong>
						</>
					)}
				/>
			</Grid>
		</Grid>
	</Grid >
);